module.exports = __webpack_public_path__ + "static/media/menu.30ab83d4.svg";